import { render, staticRenderFns } from "./IssueReasonReportView.vue?vue&type=template&id=569c5b8e&"
import script from "./IssueReasonReportView.vue?vue&type=script&lang=js&"
export * from "./IssueReasonReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports